import React, { Fragment } from 'react';

import { MoonLoader } from 'react-spinners';

export interface LoaderProps {
  hasBackdrop?: boolean;
  color?: string;
}
export default function Loader({ hasBackdrop = false, color = '#fff' }: LoaderProps) {
  return (
    <Fragment>
      {hasBackdrop ? (
        <div className="loader">
          <MoonLoader color={color} />
        </div>
      ) : (
        <span
          className="loader--small"
          style={{
            border: `2px solid ${color ?? '#fff'}`,
            borderBottomColor: 'transparent',
          }}
        ></span>
      )}
    </Fragment>
  );
}
